export default __webpack_public_path__ + "static/media/shade-f.95f7d2b2.svg";